var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":("https://chart.apis.google.com/chart?cht=qr&chs=" + _vm.width + "x" + _vm.height + "&chl=" + _vm.url)}})}
var staticRenderFns = []

export { render, staticRenderFns }